import React from "react";

import { makeStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

import { PageHeader, PageFooter, SaveButton, SimpleForm, FileInput, FileField, required } from "jazasoft";
import useMutation from "../../hooks/useMutation";
import { isEmpty } from "../../utils/helpers";

const FormFooter = ({ saving, onCancel, ...props }) => {
  return (
    <PageFooter>
      <SaveButton label="Submit" saving={saving} {...props} />
    </PageFooter>
  );
};

const useStyles = makeStyles(theme => ({
  constainer: {
    margin: theme.spacing(3)
  },
  padding: {
    padding: theme.spacing(3)
  }
}));

const MergeRolls = props => {
  const classes = useStyles();

  const [download, { loading }] = useMutation({ rawResponse: true });

  const onSubmit = ({ files }) => {
    if (isEmpty(files)) return;

    const formData = new FormData();
    files.forEach(file => formData.append("files", file.rawFile));

    const options = {
      url: `dev/merge-rolls`,
      method: "post",
      responseType: "arraybuffer",
      data: formData
    };

    download(options, {
      onSuccess: response => {
        const header = response.headers["content-disposition"];
        var filename = header ? header.match(/filename="(.+)"/)[1] : "ROLLS.xlsx";
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }
    });
  };

  return (
    <div>
      <PageHeader title="Merge Rolls" />

      <div className={classes.constainer}>
        <Paper className={classes.padding}>
          <SimpleForm saving={loading} onSubmit={onSubmit} footer={<FormFooter saving={loading} />}>
            <FileInput
              source="files"
              label="Excel Files"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              xs={12}
              fullWidth
              multiple
              validate={[required()]}>
              <FileField source="src" title="title" />
            </FileInput>
          </SimpleForm>
        </Paper>
      </div>
    </div>
  );
};

export default MergeRolls;
